import {
	ModalOverlay,
	useDisclosure,
	Image,
	Text,
	Flex,
	Button,
} from '@chakra-ui/react'
import { useState } from 'react'
import ControlPanelElement from '../ControlPanelElement'
import { Modal, ModalBody, ModalContent, ModalHeader } from '@chakra-ui/react'
import { Walkway } from '../../Data/Types'
export interface ProjectionImage {
	id: Walkway
	uri: string
}
interface ImageModalProps {
	projectionImages: ProjectionImage[]
	title: string
	onImageSelect: (image: ProjectionImage) => void
	selectedImage?: ProjectionImage
	disabled?: boolean
}
const ImageModalPicker: React.FC<ImageModalProps> = ({
	projectionImages,
	onImageSelect,
	selectedImage,
	title,
	disabled = false,
}) => {
	const { onOpen, onClose, isOpen } = useDisclosure()

	return (
		<ControlPanelElement
			flexProps={{ cursor: 'pointer', marginTop: '-.75rem', as: 'button' }}
			onClick={disabled ? undefined : onOpen}
			title={title}
		>
			{selectedImage ? (
				<Image
					width="80%"
					bg={selectedImage.id === 'AOG141XXX' ? '#ACACB0' : 'white'}
					src={selectedImage.uri}
				/>
			) : (
				<Flex>
					<Text textAlign={'center'}> Select a Projection</Text>
				</Flex>
			)}
			<Modal size={['sm', null, '3xl']} isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent borderRadius={'lg'}>
					<ModalHeader
						borderTopRadius={'lg'}
						textAlign={'center'}
						color="white"
						fontWeight={'bold'}
						fontSize={'1.75rem'}
						bg="orange.500"
					>
						Select Image
					</ModalHeader>
					<ModalBody p="1rem">
						<Flex
							gap="2rem"
							align="center"
							justify={'center'}
							flexWrap={'wrap'}
						>
							{projectionImages.map((image) => (
								<Button
									onClick={() => {
										onImageSelect(image)
										onClose()
									}}
									variant={'unstyled'}
								>
									<Image
										objectFit={'cover'}
										bg={image.id === 'AOG141XXX' ? '#ACACB0' : 'white'}
										border="4px solid"
										borderColor={image.id === 'AOG141XXX' ? '#ACACB0' : 'white'}
										id={image.id}
										_hover={{
											cursor: 'pointer',
											transform: 'scale(1.2)',
										}}
										transition="all 0.2s ease-in-out"
										width="6rem"
										transform={
											selectedImage?.id === image.id ? 'scale(1.2)' : 'scale(1)'
										}
										height={'3rem'}
										key={image.id}
										src={image.uri}
									/>
								</Button>
							))}
						</Flex>
					</ModalBody>
				</ModalContent>
			</Modal>
		</ControlPanelElement>
	)
}

export default ImageModalPicker
